import { render } from "./comunicaciones_form_multiasistencia.vue?vue&type=template&id=6ef6c58e&scoped=true"
import script from "./comunicaciones_form_multiasistencia.vue?vue&type=script&lang=js"
export * from "./comunicaciones_form_multiasistencia.vue?vue&type=script&lang=js"

import "./comunicaciones_form_multiasistencia.vue?vue&type=style&index=0&id=6ef6c58e&scoped=true&lang=css"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ef6c58e"]])

export default __exports__